import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  display: flex;
  min-height: 80vh;
  align-items: stretch;
`;

export const BackgroundWrapper = styled.div`
  width: 50%;
  background: ${(props) => props.theme.color.blue.default};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  ${mediaQuery('medium')} {
    display: none;
  }
`;

export const Background = styled.img`
  width: auto;
  max-width: 80%;
  height: auto;
  padding: 30px;
  padding-bottom: 0;
  ${mediaQuery('max')} {
    max-width: 100%;
  }
`;

export const MainWrapper = styled.div`
  width: 50%;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mediaQuery('medium')} {
    width: 100%;
  }
`;

export const Main = styled.div`
  max-width: 450px;
  flex-grow: 1;
`;
